import { render, staticRenderFns } from "./DiabetesTools.vue?vue&type=template&id=0c81303b&scoped=true&"
import script from "./DiabetesTools.vue?vue&type=script&lang=js&"
export * from "./DiabetesTools.vue?vue&type=script&lang=js&"
import style0 from "./DiabetesTools.vue?vue&type=style&index=0&id=0c81303b&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0c81303b",
  null
  
)

export default component.exports